<template>
	<div id="panel_dashboard" class="panel">
		<div class="panel-hdr bg-primary-500 bg-success-gradient">
			<h2>
				Мій кабінет
			</h2>
			<div class="panel-toolbar">
				<button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
			</div>
		</div>

		<div class="panel-container show">
			<div class="panel-content shadow">

				<b-overlay :show="is_load">
					<b-tabs content-class="mt-3">
						<b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
							   :title="get_tab_title(tab)"
							   :key="index"
							   :active="tab.is_active"
						>
							<template slot="title">
								{{get_tab_title(tab)}}
								<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
							</template>

							<component @loading="set_loading" v-bind:is="tab.index" :user_id=parseInt(user_id)></component>
						</b-tab>
					</b-tabs>
				</b-overlay>
			</div>
		</div>
	</div>
</template>

<script>

import main_settings from "./tabs/main";
import equipment from "../../shared/user/modal/tabs/equipment";
import mobile from "../../shared/user/modal/tabs/mobile";
import mobile_tarif from "./tabs/mobile_tarif";
import filexchange from "./tabs/filexchange";
import avatar from "./tabs/avatar";
import redirect from "./tabs/redirect.vue";

export default {
	name: "user_settings",
	components : {
		equipment,
		mobile,
		main_settings,
		mobile_tarif,
		//	filexchange,
		avatar,
		redirect,
	},
	props : {
		user_id : {
			type : String,
			required : true,
		}
	},

	data () {
		return  {
			is_load : false,
			tabs : [],
			tabs_default : [
				{
					index : "main_settings",
					title : "Налаштування"
				},
				{
					index : "redirect",
					title : "Переадресація службових"
				},
				{
					index : "equipment",
					title : "Оргтехніка"
				},
				{
					index : "mobile",
					title : "Моб. зв'язок (Витрати)"
				},
				{
					index : "mobile_tarif",
					title : "Моб. зв'язок (Тарифи)"
				},

				/*{
					index : "filexchange",
					title : "FileExchange"
				},*/

				{
					index : "avatar",
					title : "Аватар"
				},
			]
		}
	},

	created() {
		this.init_tabs(this.tabs_default);
	},

	methods : {
		set_loading(tab,state) {
			if(state == true) {
				IMC_CORE.showloading();
			}
			else {
				IMC_CORE.hideloading();
			}
		},

		async init_tabs(tabs_in) {
			this.tabs = [];
			tabs_in.map(tab => {
				if(tab.hasOwnProperty("index")) {
					this.tabs.push({
						'index' : tab.index,
						'title' : tab.title,
						'is_load' : false,
						'is_active' : tab.index === 'main'
					});
				}
			});
			this.is_loading = false;
		},

		get_tab_title(tab) {
			if (tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active(obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}
			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},
	}

}
</script>

<style scoped>

</style>
